module.exports = "https://r.zoocdn.com/_next/static/images/cookies-f26426c84161184c41aab2e499aee174.svg";